import React from "react";

// Use the ESM build directly to avoid the UMD/IIFE browser bundle which expects a global `React`
import ReactApexChart from "react-apexcharts";

const RenderChart = ({ data, showCards }) => {
  const chartOptions = {
    ...data.options,
    tooltip: {
      y: {
        formatter: (val) => val.toFixed(2),
      },
    },
    dataLabels: {
      formatter: (val) => val.toFixed(2),
    },
    yaxis: {
      labels: {
        formatter: (val) => val.toFixed(2), // Format y-axis values
      },
    },
  };

  return (
    <div
      className={
        showCards
          ? "card report-card d-flex flex-direction-row algin-items-center"
          : ""
      }
    >
      <div
        className={showCards ? "card-body" : ""}
        style={{ height: "100%", width: "100%" }}
      >
        <div id="chart">
          <ReactApexChart
            options={chartOptions}
            series={data.series}
            type={data.type}
            height={350}
          />
        </div>
      </div>
    </div>
  );
};

export default RenderChart;
